// Wire shape of one row (`document-type-basic` serialization group). `account` is on the wire (the
// inherited `id` group) but is never read on the front: the account a type belongs to is already
// known from the list it is fetched into (`DocumentTypesListView.accountId`), carried on this action
// rather than on each entry.
export type DocumentTypePayload = {
	readonly id: number;
	readonly key: string;
	readonly label: string;
	readonly isSystem: boolean;
	readonly archivedAt: string | null;
};

export type DocumentTypesFetchedPayload = DocumentTypePayload[];

export type DocumentTypesFetchedAction = {
	type: 'DOCUMENT_TYPES_FETCHED';
	payload: DocumentTypesFetchedPayload;
	accountId: number;
};

export default (payload: DocumentTypesFetchedPayload, accountId: number): DocumentTypesFetchedAction => ({
	type: 'DOCUMENT_TYPES_FETCHED',
	payload,
	accountId,
});
